module.exports = __webpack_public_path__ + "static/img/jc-6.00fa9a98.webp";